import classNames from 'classnames';
import React, { useRef, useState } from 'react';
import { useLocale } from '../../services/i18n/useLocale';
import { getLocaleSettings } from '../../utils';
import { useWidget } from '../widgets';

import { Wrapper } from './NewsletterForm.styles';

import trads from './trads';

// Fournisseur actif : 'mailchimp' (JSONP direct) ou 'brevo' (Cloud Function
// /api/newsletter). Brevo est prêt côté code et infra mais la bascule a été
// faite trop tôt ; repasser sur 'brevo' quand les listes seront prêtes.
const NEWSLETTER_PROVIDER = 'mailchimp';

const submitMailchimp = async (email, locale = 'fr') => {
  const mailchimpId = getLocaleSettings(locale).mailchimpId;
  const mailchimpUrl = `https://ipone.us6.list-manage.com/subscribe/post-json?u=97a03d45e032440cea22ba355&amp;id=${mailchimpId}`;

  const { default: jsonp } = await import(
    /* webpackChunkName: "jsonp" */ 'jsonp'
  );

  await new Promise((resolve, reject) => {
    jsonp(
      `${mailchimpUrl}&EMAIL=${encodeURIComponent(
        email
      )}&NEWSLETTER=Oui&LOCALE=${locale}`,
      { param: 'c' },
      (err) => (err ? reject(err) : resolve())
    );
  });
};

const submitBrevo = async (email, locale = 'fr') => {
  const resp = await fetch('/api/newsletter', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, locale }),
  });

  if (!resp.ok) {
    throw new Error(`subscription failed (${resp.status})`);
  }
};

const submit =
  NEWSLETTER_PROVIDER === 'mailchimp' ? submitMailchimp : submitBrevo;

const NewsletterForm = ({ submitIcon }) => {
  const intl = useLocale();
  const ref = useRef();
  const [status, setStatus] = useState(null);
  const infos = useWidget('newsletter');

  React.useEffect(() => {
    if (!status) {
      return;
    }
    const timeout = setTimeout(() => setStatus(null), 5000);

    return () => clearTimeout(timeout);
  }, [status]);

  const errorMessage =
    intl.formatMessage(trads.newsletterError) ||
    'Oups, une erreur est survenue';

  return (
    <Wrapper
      onSubmit={async (e) => {
        e.preventDefault();
        e.stopPropagation();
        try {
          await submit(ref.current.value, intl.locale);
          setStatus('added');
          ref.current.value = '';
        } catch (err) {
          setStatus('error');
        }
        return false;
      }}
    >
      <div className="field">
        <input
          ref={ref}
          type="email"
          placeholder={
            status === 'added'
              ? intl.formatMessage(trads.newsletterThankYou)
              : infos.placeholder
          }
          name="EMAIL"
          aria-label={infos.placeholder}
          className={status || ''}
        />
        {status === 'error' ? (
          <p className="error-message" role="alert">
            {errorMessage}
          </p>
        ) : null}
      </div>
      <button
        type="submit"
        className={classNames('clear simple-link block', {
          'simple-link': !submitIcon,
        })}
      >
        {submitIcon ? submitIcon : infos.submitText}
      </button>
    </Wrapper>
  );
};

export default NewsletterForm;
